module.exports = __webpack_public_path__ + "static/media/about.4fda867b.jpg";